import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItem } from '../../../spacesPlatform/models/resourceParts';
import { IUser } from '../../../userManagement/users/serverApi/types/IUser';
import { ISimulation } from '../types/ISimulation';

export interface IGetSimulationsParams extends IGetItemsParams {
}

export interface IGetSimulationsResult extends IGetItemsResult {
  simulations?: ISimulation[];
  users?: IUser[];
  projects?: INamedItem[];
  favorites?: string[];
}

export class GetSimulationsRequest extends Request<IGetSimulationsParams, IGetSimulationsResult> {
  constructor(params: IGetSimulationsParams) {
    super('getSimulations', params);
  }
}
